<template>
  <template v-if="question.format === 'radio'">
    <form autocomplete="off">
      <div class="form-group">
        <div class="custom-control custom-radio">
          <input type="radio" :id="this.answer.id" :name="'customnm' + index" :checked=isChecked(this.answer.id)
            class="custom-control-input   " />
          <label class="ml-2 capitalize" :for="'custom' + index">{{ this.answer.title }}</label>
        </div>
      </div>
    </form>
  </template>
</template>

<script>
export default {
  props: ["index", "answer", "question", "review"],
  methods: {
    isChecked(answerId) {
      for (var i = 0; i < this.review.responses.length; i++) {
        if (this.review.responses[i].answer_id === answerId) {
          return true
        }
      }
      return false;
    }
  }
};
</script>